/**
 * Renders a schema.org JSON-LD block inside the page. Rendered in the body
 * (valid for Google/Bing) so the build-time prerender snapshot captures it
 * per route. `<` is escaped so user-provided strings can't close the tag.
 */
export function JsonLd({ data }: { data: object }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, "\\u003c") }}
    />
  );
}
